import React, { useState, useEffect } from "react";
import "./App.css";
import Preloader from "./components/Preloader";
import CustomCursor from "./components/CustomCursor";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import Products from "./components/Products";
import HallOfFame from "./components/HallOfFame";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [currentPage, setCurrentPage] = useState("home");

  // Custom navigate handler that updates the window history path
  const navigate = (pageName) => {
    let path = "/";
    if (pageName === "about") path = "/about-us";
    else if (pageName === "products") path = "/products";
    else if (pageName === "awards") path = "/hall-of-fame";
    else if (pageName === "contact") path = "/contact-us";
    
    window.history.pushState({}, "", path);
    setCurrentPage(pageName);
  };

  // Sync state with URL path on load and browser navigation (Back/Forward)
  useEffect(() => {
    const handleLocation = () => {
      const path = window.location.pathname;
      if (path === "/about-us" || path === "/about") {
        setCurrentPage("about");
      } else if (path === "/products") {
        setCurrentPage("products");
      } else if (path === "/hall-of-fame" || path === "/awards") {
        setCurrentPage("awards");
      } else if (path === "/contact-us" || path === "/contact") {
        setCurrentPage("contact");
      } else {
        setCurrentPage("home");
      }
    };

    handleLocation();

    window.addEventListener("popstate", handleLocation);
    return () => window.removeEventListener("popstate", handleLocation);
  }, []);

  // Update document title and meta description dynamically based on the current page for SEO
  useEffect(() => {
    let title = "Vinayak Agro Chemicals | Premium Pesticides, Seeds & Fertilizers in Gujarat";
    let metaDescription = "Vinayak Agro Chemicals is Bhavnagar's leading distributor of 100% original premium pesticides, hybrid seeds, and fertilizers. Partnering with top brands like Sumitomo, Heranba, and IIL India.";

    switch (currentPage) {
      case "home":
        title = "Vinayak Agro Chemicals | Premium Pesticides, Seeds & Fertilizers in Bhavnagar, Gujarat";
        metaDescription = "Vinayak Agro Chemicals is Bhavnagar's leading distributor of 100% original premium pesticides, hybrid seeds, and fertilizers. Empowering Gujarat farmers with top brands like Sumitomo, Heranba, and IIL India for higher crop yields.";
        break;
      case "about":
        title = "About Us | Vinayak Agro Chemicals - Serving Bhavnagar Farmers";
        metaDescription = "Established in Bhavnagar, Gujarat, Vinayak Agro Chemicals is a trusted distributor of original crop protection chemicals, hybrid seeds, and fertilizers. Meet our founders Chandu Faldu & Jaydip Faldu.";
        break;
      case "products":
        title = "Product Catalog | Insecticides, Fungicides & PGRs | Vinayak Agro Chemicals";
        metaDescription = "Browse our extensive catalog of high-quality agrochemicals, including insecticides, fungicides, herbicides, and plant growth regulators (PGR) from Sumitomo Chemical, Heranba Industries, and IIL India.";
        break;
      case "awards":
        title = "Hall of Fame & Awards | Vinayak Agro Chemicals";
        metaDescription = "Celebrating our milestones and recognitions as an authorized premium distributor of crop protection, seeds, and fertilizers in Saurashtra, Gujarat.";
        break;
      case "contact":
        title = "Contact Us | Vinayak Agro Chemicals - Bhavnagar, Gujarat";
        metaDescription = "Get in touch with Vinayak Agro Chemicals. Call CEO Jaydip Faldu or Founder Chandu Faldu, email us, or visit our shop in Bhavnagar for expert agro solutions.";
        break;
      default:
        break;
    }

    document.title = title;

    // Dynamically update the meta description tag
    const metaDescriptionTag = document.querySelector('meta[name="description"]');
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute("content", metaDescription);
    }
  }, [currentPage]);

  // Determine which page content to render based on selection
  const renderPage = () => {
    switch (currentPage) {
      case "home":
        return <Home setCurrentPage={navigate} />;
      case "about":
        return <AboutUs />;
      case "products":
        return <Products />;
      case "awards":
        return <HallOfFame />;
      case "contact":
        return <Contact />;
      default:
        return <Home setCurrentPage={navigate} />;
    }
  };

  return (
    <div className="App">
      <CustomCursor />
      <Preloader />
      <Navbar currentPage={currentPage} setCurrentPage={navigate} />
      
      <main className="main-content">
        {renderPage()}
      </main>

      <Footer setCurrentPage={navigate} />

      <ScrollToTop />
    </div>
  );
}

export default App;
